import React from 'react'
import { Text } from '@react-three/drei';
import { useSelector } from 'react-redux';


export default function TextPlane({ text, position }) {
    const darkTheme = useSelector(state => state.uiMenuState.darkTheme);

    // Mostra i numeri dei lati sulla griglia di base
    return (    
        <Text
            color={darkTheme ? "#FFFF00" : "orange"} position={position} rotation={[-Math.PI/2, 0, Math.PI/2]}
            characters="abcdefghijklmnopqrstuvwxyz0123456789!"
            fontSize={0.5}           
        >{text}</Text>     
    )
}
